export default "__VITE_ASSET__BaYS1SMI__"